module.exports = __webpack_public_path__ + "f7a10f9f1db059bab934d0b74a32be18.svg";